import Select, { OptionProps } from '@storeblocks/select';
import { type FC, useState } from 'react';

import { useFetchFundHoldingsQuery } from '@/api/fundHoldings/fundHoldingsApi';
import { useTexts } from '@/hooks/useTexts';
import { CurrencyCode } from '@/types/CurrencyCode';

interface Props {
  initialCurrency: CurrencyCode | undefined;
  portfolioShortName: string;
  onChange: (currency: string) => void;
}

export const CurrencySelector: FC<Props> = ({
  initialCurrency,
  portfolioShortName,
  onChange,
}) => {
  const { orders } = useTexts();
  const { data: fundHoldings } = useFetchFundHoldingsQuery();

  const currencies = Object.keys(
    fundHoldings!.byPortfolioId[portfolioShortName].byCurrency,
  );

  const [selectedCurrency, setSelectedCurrency] = useState<string>(
    initialCurrency || '',
  );

  const options = currencies.map<OptionProps>((currency) => ({
    value: currency,
    label: currency,
  }));

  const handleOnChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ): void => {
    setSelectedCurrency(event.target.value);
    onChange(event.target.value);
  };

  return (
    <Select
      name="selectedCurrency"
      id="currency-selector"
      label={orders.form.currency.title}
      hint={orders.form.currency.message}
      placeholder={orders.form.currency.placeholder}
      options={options}
      value={selectedCurrency}
      onChange={handleOnChange}
    />
  );
};
